/**
 * Live shopping widget slide.
 */
class LiveShoppingSlide {
  /**
   * Prepares the counter.
   * @param {jQuery} $this $this
   * @param {number} timestampEndInt Timestamp end in seconds.
   */
  static prepareCounter($this, timestampEndInt) {
    if ($this.find('.scarcity .hours').length > 0) {
      return;
    }
    const diff = this.getTimestampDiff(timestampEndInt);
    const { hours = '0', minutes = '0', seconds = '0' } = this.getTimeParts(diff);

    const scarcity = `
    <p class="scarcity text-danger text-right">
        <i class="sg sg-countdown"></i>
        <span class="hours">${this.addLeadingZero(hours)}</span>
        <span class="minutes">${this.addLeadingZero(minutes)}</span>
        <span class="seconds" data-info="h">${this.addLeadingZero(seconds)}</span>
    </p>
  `;

    $this.find('.progress-bar-container').html(scarcity);
  }

  /**
   * Gets number of seconds until timestampEnd.
   *
   * @param {number} timestampEndInt Timestamp end in seconds.
   * @return {number}
   */
  static getTimestampDiff(timestampEndInt) {
    return timestampEndInt - Math.round(Date.now() / 1000);
  }

  /**
   * Checks is slide should be still visible.
   *
   * @param {number} timestampEndInt Timestamp in seconds.
   * @return {bool} True if slide should still be visible.
   */
  static shouldSlideBeVisible(timestampEndInt) {
    return this.getTimestampDiff(timestampEndInt) > 0;
  }

  /**
   * Gets hour, minutes and seconds from a diff.
   * @param {number} diff Diff in seconds
   * @return {Object}
   */
  static getTimeParts(diff) {
    if (diff < 0) {
      return {
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }
    return {
      hours: Math.floor(diff / (60 * 60)),
      minutes: Math.floor((diff % (60 * 60)) / 60),
      seconds: Math.ceil((diff % (60 * 60)) % 60),
    };
  }

  /**
   * Hides slide and trigger HIDE event.
   * @param {jQuery} $this $this
   */
  static hideSlide($this) {
    $this.trigger(this.events.LIVE_SHOPPING_SLIDE_HIDE);
  }

  /**
   * Adds leading zero
   * @param {number} number Number
   * @return {string}
   */
  static addLeadingZero(number) {
    return (number < 10 ? '0' : '') + number;
  }

  /**
   * Events
   * @return {Object}
   */
  static get events() {
    return {
      LIVE_SHOPPING_SLIDE_HIDE: 'LIVE_SHOPPING_SLIDE_HIDE',
    };
  }

  /**
   * Updates the countdown.
   * @param {jQuery} $this $this element.
   * @param {number} timestampEnd Timestamp end in seconds.
   * @return {jQuery}
   */
  static updateCountDown($this, timestampEnd) {
    const diff = this.getTimestampDiff(timestampEnd);
    const { hours = '0', minutes = '0', seconds = '0' } = this.getTimeParts(diff);
    const $scarity = $this.find('.scarcity');

    $scarity.find('.hours').html(this.addLeadingZero(hours));
    $scarity.find('.minutes').html(this.addLeadingZero(minutes));
    $scarity.find('.seconds').html(this.addLeadingZero(seconds));

    return $this;
  };

  /**
   * Checks if should show the countdown.
   * @param {number} timestampEnd Timestamp end in seconds.
   */
  static shouldShowCountDown(timestampEnd) {
    const diff = this.getTimestampDiff(timestampEnd);
    return diff < 86400; // 1 day in seconds
  }

  /**
   * Scope helper function. setTimeout must be calles in window scope.
   * @param {*} args Args.
   */
  static callSetTimeout(...args) {
    return setTimeout(...args);
  }

  /**
   * Scope helper function. setInterval must be calles in window scope.
   * @param {*} args Args.
   */
  static callSetInterval(...args) {
    return setInterval(...args);
  }
  /**
   * Constructs.
   * @param {jQuery} $ jQuery
   * @param {jQuery} $this jQuery $(this)
   * @param {TaggedLogger} logger Logger.
   * @param {Object} options Options.
   */
  constructor($, $this, logger, { updateInterval = 1000, timeoutFunction, intervalFunction }) {
    this.$ = $;
    this.$container = $this;
    this.logger = logger;
    this.updateInterval = updateInterval;
    this.timestampEnd = this.$container.data('timestamp-end');
    this.timestampEndInt = parseInt(this.timestampEnd, 10);
    this.setTimeout = timeoutFunction || this.constructor.callSetTimeout;
    this.setInterval = intervalFunction || this.constructor.callSetInterval;
  }

  /**
   * Starts the showroom mode.
   * Counter will be dynamically change every 6 seconds.
   * @param {number} seconds Delay for each step.
   */
  startShowroomMode(seconds) {
    this.setTimeout(() => {
      this.logger.info('Showroom mode. One day only!');
      this.timestampEndInt = Math.round(Date.now() / 1000) + 86403;
    }, 1000 * seconds);

    this.setTimeout(() => {
      this.logger.info('Showroom mode. 12 hours!');
      this.timestampEndInt = Math.round(Date.now() / 1000) + (86402 / 2);
    }, 2000 * seconds);

    this.setTimeout(() => {
      this.logger.info('Showroom mode. 1 hour!');
      this.timestampEndInt = Math.round(Date.now() / 1000) + 3600;
    }, 3000 * seconds);

    this.setTimeout(() => {
      this.logger.info('Showroom mode. 10 minutes!');
      this.timestampEndInt = Math.round(Date.now() / 1000) + 600;
    }, 4000 * seconds);

    this.setTimeout(() => {
      this.logger.info('Showroom mode. 1 minute!');
      this.timestampEndInt = Math.round(Date.now() / 1000) + 61;
    }, 5000 * seconds);

    this.setTimeout(() => {
      this.logger.info('Showroom mode. 5 seconds!');
      this.timestampEndInt = Math.round(Date.now() / 1000) + 5;
    }, 6000 * seconds);
  }

  /**
   * Prepares counter if needed. Watches the slide if is expired.
   */
  start() {
    if (!this.$.isNumeric(this.timestampEnd)) {
      this.logger.info('No timestampEnd. Aborting.');
      return;
    }

    if (this.constructor.shouldSlideBeVisible(this.timestampEndInt) === false) {
      this.constructor.hideSlide(this.$container);
      return;
    }

    if (this.constructor.shouldShowCountDown(this.timestampEndInt)) {
      this.constructor.prepareCounter(this.$container, this.timestampEndInt);
    }

    const interval = this.setInterval(() => {
      if (this.constructor.shouldSlideBeVisible(this.timestampEndInt) === false) {
        this.constructor.hideSlide(this.$container);
        clearInterval(interval);
        return;
      }
      if (this.constructor.shouldShowCountDown(this.timestampEndInt)) {
        this.constructor.prepareCounter(this.$container, this.timestampEndInt);
        this.constructor.updateCountDown(this.$container, this.timestampEndInt);
      }
    }, this.updateInterval);

    if (
      typeof localStorage !== 'undefined'
      && typeof localStorage.getItem === 'function'
      && localStorage.getItem('liveShoppingShowroom') > 0
    ) {
      this.startShowroomMode(localStorage.getItem('liveShoppingShowroom'));
    }
  }
}

export default LiveShoppingSlide;



// WEBPACK FOOTER //
// ./Library/1.0/common/widgets/live-shopping-widget.js